import { defineComponent as _defineComponent } from 'vue'
import { i18n } from '@/assets/i18n';
import { ref } from 'vue';
import { ENV } from '../../env';
import { Connection, store } from '../store';

export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  emits: ['onClose'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const PACKAGE = require('../../package.json');
const version = PACKAGE.version;
const emit = __emit;

const settings: Connection[] = ENV;
let selected = ref<{ [key: string]: string }>(store.connection);

function close(): void {
  emit('onClose');
}

function select(c: Connection): void {
  selected.value = c;
  c && store.setConnection(c);
}

function isSelected(c: Connection): boolean {
  return c.NAME === selected.value?.NAME;
}

function getField(key: string) {
  return selected.value[key];
}

const __returned__ = { PACKAGE, version, emit, settings, get selected() { return selected }, set selected(v) { selected = v }, close, select, isSelected, getField, get i18n() { return i18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})